import {createSlice} from "@reduxjs/toolkit";
import {getMenuList} from "@/store/menu-list/action";

const initialState = {
  state: {
    menuList: window.localStorage.getItem('menu_list') || []
  },
  loading: true,
  error: ''
} as BaseState<MenuListState>

const slice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMenuList.pending, (state) => ({
        ...state,
        loading: true
      }))
    builder.addCase(getMenuList.fulfilled, (state, action) => ({
      state: {
        menuList: [...action.payload]
      },
      error: null,
      loading: false
    }))
    builder.addCase(getMenuList.rejected, (state) => ({
        ...state,
        loading: true,
        error: 'Failed to get menu list'
      }))
  }
})

export default slice
